import { type v2 } from '@deque/billing-service-client';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PlanName from '../../app/components/PlanName';
import { useAuthContext } from '../contexts/auth';
import { useEnterprises } from '../contexts/enterprises';
import ProductLogo from './ProductLogo';

export interface ProductHeaderProps {
  // TODO: We should be able to derive this from a product slug, but we need to
  // consolidate the way we are handling loading.
  // See: https://github.com/dequelabs/walnut/issues/2934
  product: v2.Product;
  // TODO: We should be able to derive this from a product slug, but we need to
  // refactor the way we are keeping track of product routes in order to do this:
  // See: https://github.com/dequelabs/walnut/issues/3382
  homeURL: string;
}

const ProductHeader = ({
  product,
  homeURL
}: ProductHeaderProps): React.ReactElement => {
  const { t } = useTranslation();
  const { billingUser } = useAuthContext();
  const {
    loading: enterprisesLoading,
    activeEnterprise,
    isAdmin
  } = useEnterprises();

  let subscription:
    | v2.EnterpriseSubscription
    | v2.UserSubscription
    | undefined = undefined;
  if (billingUser && !enterprisesLoading) {
    let subscriptions: (v2.EnterpriseSubscription | v2.UserSubscription)[] = [];
    if (billingUser.enterprises[0] && activeEnterprise) {
      subscriptions = isAdmin
        ? activeEnterprise.subscriptions
        : billingUser.enterprises[0].subscriptions;
    } else {
      subscriptions = billingUser.subscriptions;
    }
    subscription = subscriptions.find(s => s.product_id === product.id);
  }

  const subtitle =
    subscription && subscription.purchase_state !== 'none' ? (
      <>
        {t('Plan: ')}
        <PlanName subscription={subscription} />
      </>
    ) : undefined;

  return (
    <ProductLogo title={product.name} subtitle={subtitle} homeURL={homeURL} />
  );
};

export default ProductHeader;
